import { useTranslation } from "../i18n";

const SPINNER_SIZE = { sm: "h-4 w-4", md: "h-8 w-8", lg: "h-10 w-10" } as const;

export function Spinner({
  size = "md",
  className,
}: {
  readonly size?: keyof typeof SPINNER_SIZE;
  readonly className?: string;
}) {
  const { t } = useTranslation("app");
  return (
    <svg
      className={`animate-spin text-slate-400 ${SPINNER_SIZE[size]}${className ? ` ${className}` : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-label={t("loading")}
      role="status"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}
